export default {"src":"/_next/static/media/spain.3f310538.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};